// public/js/components/button-loader.js

export default function ButtonLoader(rootEl) {
  const content = rootEl.querySelector('.btn-content');
  const spinner = rootEl.querySelector('.btn-spinner');
  
  if (!content || !spinner) {
    console.warn('ButtonLoader: Missing required elements', rootEl);
    return;
  }

  const startLoading = () => {
    requestAnimationFrame(() => {
      content.classList.add('invisible');
      spinner.classList.remove('hidden');
      rootEl.classList.add('pointer-events-none', 'opacity-80');
      rootEl.setAttribute('aria-busy', 'true');
    });
  };

  const reset = () => {
    requestAnimationFrame(() => {
      content.classList.remove('invisible');
      spinner.classList.add('hidden');
      rootEl.classList.remove('pointer-events-none', 'opacity-80');
      rootEl.removeAttribute('aria-busy');
    });
  };

  rootEl.stopLoading = reset;

  window.addEventListener('pageshow', reset);

  rootEl.addEventListener('click', (e) => {
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;

    if (rootEl.classList.contains('opacity-80')) {
      e.preventDefault();
      return;
    }

    if (rootEl.tagName === 'BUTTON' && rootEl.type === 'submit') {
      const form = rootEl.closest('form');
      if (form) {
        // We start loading immediately on click if basic HTML validity passes.
        // If custom validation in main.js fails later, it will call stopLoading().
        if (form.checkValidity()) {
          startLoading();
        }
      }
    } 
    else if (rootEl.tagName === 'A' && rootEl.getAttribute('href') !== '#') {
      if (rootEl.hasAttribute('download') || rootEl.getAttribute('target') === '_blank' || rootEl.getAttribute('href').startsWith('javascript:')) {
        return;
      }
      startLoading();
    }
  });
}